import { render, staticRenderFns } from "./base-autocomplete.vue?vue&type=template&id=3f0fe8d0"
import script from "./base-autocomplete.vue?vue&type=script&lang=js"
export * from "./base-autocomplete.vue?vue&type=script&lang=js"
import style0 from "./base-autocomplete.vue?vue&type=style&index=0&id=3f0fe8d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports